
import styled from 'styled-components';
import { SummaryPlayEventsWrapper, IconWrapper } from '../Play/play/SummaryPlayEvents.style';

export const FirstPitchWrapper = styled(SummaryPlayEventsWrapper)`
    font-family: var(--gameday-primary-font);
    color: var(--gameday-summary-play-event-color);
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    position: relative;

    ${({ $showImage }) => ({ $showImage }) => {
        if (!$showImage) {
            return `
                padding-left:0;
            `;
        }
    }}

    ${IconWrapper} {
        width: 48px;
        height: 48px;
    }
`;

export const GameTimeWrapper = styled.div`
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color: var(--gameday-primary-font-color);
`;

export const TitleWrapper = styled.div``;

export const VenueWrapper = styled.div`
    color: var(--gameday-primary-font-color);
    font-weight: 500;
    font-size: 18px;
`;
